site.extendedmenu = {
	init: function() {
		return false;
		$('document').ready(function() {
			site.extendedmenu.splitMenu();
		})
		$(window).on('resize', function() {
			site.extendedmenu.splitMenu();
		});
	},

	splitMenu: function() {
		var $body = $('body'),
			mainmenu = $('#mainmenu'),
			nodes = mainmenu.find('.mmLevel1 > li'),
			mmWidth = mainmenu.width() + 28,
			totalWidth = 0,
			extendedMenu = $('.extendedMenu');
		extendedMenu.remove();
		nodes.removeClass('extended');
		$body.removeClass('menuIsExtended');
		if ($(window).width() > 1500) {
			return;
		}
		nodes.each(function() {
			const nodeWidth = $(this)[0].scrollWidth;
			totalWidth += nodeWidth;
			if (totalWidth > mmWidth - 30) {
				if (!$('.extendedMenu').length) {
					mainmenu.after('<div class="extendedMenu"><ul class="menu mmLevel1"></ul></div>');
				}
				$('.extendedMenu ul').append($(this)[0].outerHTML);
				$(this).addClass('extended');
			}

		});
		if ($('.level1.extended').length) {
			$body.addClass('menuIsExtended');
		}
		$('.extendedMenu').hover(function() {
			$('#mainmenu').addClass('hover');
		}, function() {
			$('#mainmenu').removeClass('hover');
		});

		var level1 = $('#mainmenu a, .extendedMenu a');
		level1.focus(function() {
			$('#mainmenu').addClass('hover');
		});
		level1.blur(function() {
			$('#mainmenu').removeClass('hover');
		});

	}
};
site.inits.push('site.extendedmenu.init()');
